import React from 'react'
import HomeInvestorLoan from "website/home/home-investor-loan.svg"
import ConstructionLoan from "website/home/construction-loan.svg"
import BridgingLoan from "website/home/bridging-loan.svg"
import SmsfLoan from "website/home/smsf-loan.svg"
import CommercialPropertyLoan from "website/home/commersial-property-loan.svg"
import IconTextCard from '../common/components/IconTextCard'

const FullyFeaturedLoans = () => (
  <div className='fully-featured-loans-container center mt-5'>
    <h2 className='white mb-5'>Fully-featured mortgage loans</h2>
    <div className='white mb-3'>At Yard we are big on both simplicity and transparency.</div>
    <div className='white'>We want to provide our customers with all the features that a big bank might provide – we just want to combine this with competitive interest rates and low fees.</div>
    <div className='mt-5 icon-text-card-container'>
        <IconTextCard
          link='/loans'
          icon={<HomeInvestorLoan />}
          iconStyle=''
          header='Home loan'
          body='Purchase or refinance a property for your own home or an investment'
        />
        <IconTextCard
          link='/loans/construction-loan'
          icon={<ConstructionLoan />}
          iconStyle=''
          header='Construction Loan'
          body='Short-term loan that provides the funds to build a residential property'
        />
        <IconTextCard
          link='/loans/bridging-loan'
          icon={<BridgingLoan />}
          iconStyle=''
          header='Bridging Loan'
          body="Consider Yard's bridging loan if you need to buy before going through the process of selling an existing property"
        />
        <IconTextCard
          link='/loans/smsf-loan'
          icon={<SmsfLoan />}
          iconStyle=''
          header='SMSF Loan'
          body='Purchase or refinance a residential and commercial property through your Self-Managed Super Fund (SMSF)'
        />
        <IconTextCard
          link='/loans/commercial-property-loan'
          icon={<CommercialPropertyLoan />}
          iconStyle=''
          header='Commercial Property Loan'
          body="Purchase or refinance a commercial property with our flexible commercial loan options"
        />
    </div>
  </div>
);

export default FullyFeaturedLoans
